import { render } from "./MatchingPayInDealsDetailsTable.vue?vue&type=template&id=dd26b558&ts=true"
import script from "./MatchingPayInDealsDetailsTable.vue?vue&type=script&lang=ts"
export * from "./MatchingPayInDealsDetailsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__